import React, { useEffect } from 'react';
import { initPixel } from './lib/fpixel';
import { TopBanner } from './components/TopBanner';
import { Hero } from './components/Hero';
import { Gallery } from './components/Gallery';
import { Problem } from './components/Problem';
import { Transformation } from './components/Transformation';
import { MainContent } from './components/MainContent';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { SalesPopup } from './components/SalesPopup';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  useEffect(() => {
    // Initialize the Meta Pixel and fire the initial PageView once on load.
    initPixel();
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-primary/20 selection:text-primary-dark" data-id="element-0">
      <TopBanner data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Gallery data-id="element-4" />
        <Problem data-id="element-5" />
        <Transformation data-id="element-6" />
        <MainContent data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Offer data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>

      <footer className="bg-gray-900 text-gray-500 py-12 text-center text-sm" data-id="element-13">
        <div className="max-w-4xl mx-auto px-6" data-id="element-14">
          <p data-id="element-15">
            © {new Date().getFullYear()} Enciclopedia Gluko Libre Argentina.
            Todos los derechos reservados.
          </p>
          <p className="mt-4 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-16">
            Este producto no sustituye el consejo médico profesional. Consulte
            siempre a su médico antes de realizar cambios en su dieta.
          </p>
        </div>
      </footer>

      <SalesPopup data-id="element-17" />
      <WhatsAppButton data-id="element-18" />
    </div>;
}